<div *ngIf="error">
  <h2 class="text-center text-strong p-3">Survey does not exists. You must set survey url in retool.</h2>
</div>
<h2 class="text-center text-strong p-3" *ngIf="!error">Thank you for your time in completing our survey.</h2>
<div class="text-center">
  <button mat-flat-button color="primary" class="nuaxia-button">
    <span  [routerLink]="['/']">Back to activities</span>
  </button>
</div>
